import DefaultApiService from "../../infrastructure/api/default";

export const loaderDashboard = async ({ url }) => {
  try {
    const res = await DefaultApiService.getDashboard(url);
    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    return res?.data || [];
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return null;
  }
};

export const loaderGridByParentID = async ({ params, url }) => {
  try {
    let treeId = params?.treeId;
    const res = await DefaultApiService.getListApiByParentId(url, treeId);
    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    return res?.data || [];
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return null;
  }
};

export const loaderGrid = async ({ url }) => {
  try {
    console.log(url);
    const res = await DefaultApiService.getListApi(url);
    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    // API response ممکن است به صورت { isSuccess: true, data: [...] } یا آرایه مستقیم باشد
    const raw = res?.data ?? res;
    const list = Array.isArray(raw?.data) ? raw.data : Array.isArray(raw) ? raw : [];
    return list;
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return [];
  }
};

export const loaderById = async ({ params, initValue, url }) => {
  try {
    let id = params?.id,
      result = {};

    if (id && id === "create") {
      id = 0;
      result = initValue;
    }

    const res = await DefaultApiService.getOneApi(url, id);

    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    if (res?.isSuccess === false && params?.id !== "create") {
      throw new Response(res.message || "خطا در دریافت اطلاعات", {
        status: res.statusCode === "UnAuthorized" ? 403 : 400,
      });
    }

    // API response ممکن است به صورت { isSuccess: true, data: { ... } } باشد
    const apiData = res?.data?.data || res?.data || res;
    const sendData = { ...apiData, ...result };

    if (sendData?.SiteVisit && !sendData?.siteVisit) {
      sendData.siteVisit = sendData.SiteVisit;
    }
    if (sendData?.PhaseCount && !sendData?.phaseCount) {
      sendData.phaseCount = sendData.PhaseCount;
    }
    if (sendData?.SiteVisitStatus && !sendData?.siteVisitStatus) {
      sendData.siteVisitStatus = sendData.SiteVisitStatus;
    }
    if (sendData?.FormAccess && !sendData?.formAccess) {
      sendData.formAccess = sendData.FormAccess;
    }
    if (sendData?.BaseUrl && !sendData?.baseUrl) {
      sendData.baseUrl = sendData.BaseUrl;
    }
    if (sendData?.Request && !sendData?.request) {
      sendData.request = sendData.Request;
    }
    if (sendData?.StepList && !sendData?.stepList) {
      sendData.stepList = sendData.StepList;
    }
    if (sendData?.TrackingMilestones && !sendData?.trackingMilestones) {
      sendData.trackingMilestones = sendData.TrackingMilestones;
    }
    if (sendData?.ParallelTrackingMilestones && !sendData?.parallelTrackingMilestones) {
      sendData.parallelTrackingMilestones = sendData.ParallelTrackingMilestones;
    }

    return sendData;
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    // اگر در حالت create بودیم و خطا رخ داد، initValue را برمی‌گردانیم
    if (params?.id === "create") {
      return initValue || {};
    }
    return null;
  }
};

export const loaderCustomUrlById = async ({ params, initValue, url }) => {
  try {
    let id = params?.id,
      result = {};

    if (id && id === "create") {
      id = 0;
      result = initValue;
    }

    const res = await DefaultApiService.getCustomeApi(url + "?id=" + id);

    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    const sendData = { ...(res?.data || {}), ...result };

    return sendData;
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return null;
  }
};

export const loaderReport = async ({ url }) => {
  try {
    const res = await DefaultApiService.getApi(url + "/GetFilterData");
    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    return res?.data || [];
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return null;
  }
};

export const loaderSimpleGet = async ({ url }) => {
  try {
    const res = await DefaultApiService.getApi(url);
    if (res?.status === 404) {
      throw new Response("Not Found", { status: 404 });
    }

    return res?.data || [];
  } catch (error) {
    if (error.code === "ERR_NETWORK") {
      throw new Response("عدم اتصال به اینترنت", { status: 599 });
    }
    return null;
  }
};
